import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import ROUTES, { makePeopleSearchURL } from 'routes';
import { useAppSelector } from 'hooks';
import { selectCounters } from 'redux/counters/selectors';
import Icon from 'components/Icon';

import css from './Navigation.module.scss';

interface Props {
    sidebarActive: boolean;
    setSidebarActive: (value: boolean) => void;
}

const Navigation: React.FC<Props> = ({ sidebarActive, setSidebarActive }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const counters = useAppSelector(selectCounters);

    const { new_messages, new_friend_requests, new_notifications, new_views } = counters;

    const alertsCounter = new_friend_requests + new_notifications + new_views;
    const messagesCounter = new_messages;

    if (location.pathname.startsWith(ROUTES.MESSAGES_HOME) && /[0-9]/.test(location.pathname)) {
        return null;
    }

    return (
        <div className={css.container}>
            <div className={css.iconContainer} onClick={() => navigate(ROUTES.HOME)}>
                <Icon name="home" width={25} color={location.pathname.includes(ROUTES.HOME) ? 'blue' : 'gray3'} />
            </div>
            <div className={css.iconContainer} onClick={() => navigate(makePeopleSearchURL())}>
                <Icon
                    name="search"
                    width={25}
                    color={location.pathname.includes(ROUTES.SEARCH_PEOPLE) ? 'blue' : 'gray3'}
                />
            </div>
            <div className={css.iconContainer} onClick={() => navigate(ROUTES.MESSAGES_HOME)}>
                <>
                    <Icon
                        name="envelope"
                        width={25}
                        color={location.pathname.includes(ROUTES.MESSAGES_HOME) ? 'blue' : 'gray3'}
                    />
                    {messagesCounter > 0 && <div className={css.iconIndicator} />}
                </>
            </div>
            <div className={css.iconContainer} onClick={() => navigate(ROUTES.ALERTS)}>
                <Icon
                    name="bell-alert"
                    width={25}
                    color={location.pathname.includes(ROUTES.ALERTS) ? 'blue' : 'gray3'}
                />
                {alertsCounter > 0 && <div className={css.iconIndicator} />}
            </div>
            <div className={css.iconContainer} onClick={() => setSidebarActive(!sidebarActive)}>
                <Icon name="menu" width={25} color={sidebarActive ? 'blue' : 'gray3'} />
            </div>
        </div>
    );
};

export default React.memo(Navigation);
